import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Card } from "../../../components/Card";
import { SectionTitle } from "../../../components/SectionTitle";
import { LoadingContainer } from "../../../components/LoadingContainer";
import { spacing } from "@styling/sizing";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { useGetEntitlementsQuery } from "../../../query/entitlementsQuery";

const SectionHeader = styled.div`
  margin-bottom: ${spacing.x2}px;
`;

const FeatureList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.x1}px;
`;

const FeatureBadge = styled.span`
  font-size: ${fontSizes.small}px;
  padding: ${spacing.x05}px ${spacing.x2}px;
  border-radius: 4px;
  background-color: ${colors.infoBackground};
  color: ${colors.info};
`;

const EmptyText = styled.p`
  margin: 0;
  color: ${colors.textMuted};
`;

export const EntitlementsSection = () => {
  const { t } = useTranslation();
  const { storeId } = useParams<{ storeId: StoreId }>();
  const { data: entitlements, isLoading } = useGetEntitlementsQuery(
    storeId ?? null
  );

  if (isLoading) {
    return (
      <Card>
        <SectionTitle>{t("entitlements.sectionTitle")}</SectionTitle>
        <LoadingContainer message={t("entitlements.loading")} />
      </Card>
    );
  }

  if (!entitlements) {
    return null;
  }

  return (
    <Card>
      <SectionHeader>
        <SectionTitle>{t("entitlements.sectionTitle")}</SectionTitle>
      </SectionHeader>

      {entitlements.features.length === 0 ? (
        <EmptyText>{t("entitlements.noFeatures")}</EmptyText>
      ) : (
        <FeatureList>
          {entitlements.features.map((feature) => (
            <FeatureBadge key={feature}>
              {t(`availableBillingItemForm.feature.${feature}`)}
            </FeatureBadge>
          ))}
        </FeatureList>
      )}
    </Card>
  );
};
